export interface GroupListFilters {
  typeId?: string
  campusId?: string
  mine?: boolean
  hasOpenSpots?: boolean
  includeArchived?: boolean
  /** Comma-separated tag ids. */
  tags?: string
}

export const groupKeys = {
  all: () => ['groups'] as const,
  types: () => [...groupKeys.all(), 'types'] as const,
  /** Tag categories and their tags — the directory's filters. */
  tagGroups: () => [...groupKeys.all(), 'tag-groups'] as const,
  /** The directory, keyed by the filters that change what comes back. */
  list: (filters: GroupListFilters = {}) => [...groupKeys.all(), 'list', filters] as const,
  detail: (id: string) => [...groupKeys.all(), 'detail', id] as const,
  roster: (id: string) => [...groupKeys.all(), 'roster', id] as const,
  requests: (id: string) => [...groupKeys.all(), 'requests', id] as const,
  /** Groups on a person's profile — invalidated by any membership change. */
  forPerson: (personId: string) => [...groupKeys.all(), 'person', personId] as const,
}
